import Swal from 'sweetalert2'

function SweetToast2({ countWords, searchType }) {
    return (
        Swal.fire({
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 3000,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            },
            text: `Por favor ingrese más datos / ${searchType}`
        })
    )
}

export default SweetToast2